//QuizConfig
import './index.css';
import React from 'react';
import { QuizConfigs, QuizSet, QuizSetting } from './types';
interface QConfigApp {
    qConfig: QuizConfigs,
    onAction: (data: QuizSetting) => void;
}

const QuizConfig: React.FC<QConfigApp> = ({ qConfig, onAction }) => {

    const [selectedQuestionSet, setSelectedQuestionSet] = React.useState<QuizSet>();
    const [noOfQuestionsToAnswer, setNoOfQuestionToAnswer] = React.useState<number>(10);
    const [selectedQuestionSetNo, setSelectedQuestionSetNo] = React.useState<number>(0);
    const [startingQuestionIndex, setStartingQuestionIndex] = React.useState<number>(1);
    const [isQuestionSelectionTypeRandom, setQuestionSelectionTypeRandom] = React.useState<boolean>(true);
    const handleQuestionSetChange = (quizSetId: number) => {
        setSelectedQuestionSet(qConfig.quizSets.find(set => set.qSetNo === quizSetId));
        setSelectedQuestionSetNo(quizSetId);
        setNoOfQuestionToAnswer(qConfig.quizSets[quizSetId - 1]?.qSetQuestions.length || 0)
    };

    const handleNumberOfQuestionsChange = (numberOfQuestions: number) => {
        setNoOfQuestionToAnswer(numberOfQuestions);
    };
    const handleQuestionSelectionType = (sel: boolean) => {
        setQuestionSelectionTypeRandom(sel);
    }
    const handleStartingQuestionIndex = (idx: number) => {
        setStartingQuestionIndex(idx);
    }
    //const handleSubmit = (selectedQuestionSet: QuizSet, numberOfQuestions: number) => {
    const handleSubmit = () => {
        const selectedQuizSet = qConfig.quizSets[selectedQuestionSetNo - 1];
        const data: QuizSetting = {
            noOfQuestionsToAnswer: noOfQuestionsToAnswer,
            selectedQuestionSetNo: selectedQuestionSetNo,
            isQuestionSetSelected: true,
            isQuestionSelectionRandom: isQuestionSelectionTypeRandom,
            startingQuestionIndex: startingQuestionIndex
        };
        onAction(data);
    };

    return (

        <div className='quiz-config-container'>
            <h3>Select Question Set and Number of Questions</h3>
            <div>
                <div className="question-set-selection">
                    <label htmlFor="questionSet">Choose a Question Set:</label>
                    &nbsp; &nbsp;
                    <select id="questionSet" style={{ minHeight: "25px", borderRadius: "4px", }} value={selectedQuestionSet?.qSetNo} onChange={(event) => handleQuestionSetChange(parseInt(event.target.value))}>
                        <option value="">--Select--</option>
                        {qConfig.quizSets.map((set) => (
                            <option key={set.qSetNo} value={set.qSetNo}>
                                {set.qSetTitle}
                            </option>
                        ))}
                    </select>
                </div>
                <div className='no-of-question-selection'>
                    <label htmlFor="numQuestions">Number of Questions:</label>
                    &nbsp; &nbsp;
                    <input
                        type="number"
                        id="numQuestions"
                        value={noOfQuestionsToAnswer}
                        onChange={(event) => handleNumberOfQuestionsChange(parseInt(event.target.value))}
                        min="1"
                        max={qConfig.quizSets[selectedQuestionSetNo - 1]?.qSetQuestions.length || 0} // Example max limit
                    />
                </div>

                <div className='question-type-selection'>
                    <label htmlFor="selectionType"> Is random selection</label>
                    &nbsp; &nbsp;
                    <input
                        type="checkbox"
                        id="selectionType"
                        checked={isQuestionSelectionTypeRandom}
                        onChange={(event) => handleQuestionSelectionType(event.target.checked)}
                    />
                    <label htmlFor="startingIndex">Staring Question Index :  </label>
                    &nbsp; &nbsp;
                    <input
                        type="number"
                        id="startingIndex"
                        //value={startingQuestionIndex}
                        hidden={isQuestionSelectionTypeRandom}
                        //placeholder='Enter the starting question index'
                        onChange={(event) => handleStartingQuestionIndex(parseInt(event.target.value))}
                        min="1"
                        max={qConfig.quizSets[selectedQuestionSetNo - 1]?.qSetQuestions.length - noOfQuestionsToAnswer || 0}
                    />
                </div>
                <input className='start-quiz-button' id="submitConfig" type="button" onClick={handleSubmit} value="Start Quiz" />
            </div>
            {selectedQuestionSet && (
                <p>You have selected the {qConfig.quizSets.find(set => set.qSetNo === selectedQuestionSet.qSetNo)?.qSetTitle} question set. and for {noOfQuestionsToAnswer} questions and starting index is {startingQuestionIndex}</p>
            )}
        </div>
    );

};

export default QuizConfig;